/**
 * @file 创建一个campaign流程中的api
 * @author caiguoqing
 */

import { CampaignMarketingStrategy } from "@/pages/campaignCreate/components/DevelopStrategy/config";
import axiosInstance from "./axiosInstance";
import { CreateCampaignStageEnum } from "@/pages/campaignCreate/config";

// 上传产品Logo 获取上传地址
export const getProductLogoUploadUrl = async (params: any) => {
  try {
    const response = await axiosInstance.post(
      `/ads/product/uploadLink/public`,
      params
    );
    return response?.data;
  } catch (error: any) {
    throw new Error(error?.message);
  }
};

// 移除画像
export const removeAdsImageApi = async (
  campaignId: string,
  personaId: string,
  objective: string
) => {
  try {
    const response = await axiosInstance.post(
      `/ads/campaign/${campaignId}/persona/${personaId}/remove`,
      { objective }
    );
    return response?.data;
  } catch (error: any) {
    throw new Error(error?.message);
  }
};

// 恢复画像
export const recoverAdsImageApi = async (
  campaignId: string,
  personaId: string
) => {
  try {
    const response = await axiosInstance.post(
      `/ads/campaign/${campaignId}/persona/${personaId}/recover`
    );
    return response?.data;
  } catch (error: any) {
    throw new Error(error?.message);
  }
};

// 获取campaign详情
export const getCampaignDetailApi = async (campaignId: string) => {
  try {
    const response = await axiosInstance.get(`/ads/campaign/v3/${campaignId}`);
    return response?.data;
  } catch (error: any) {
    throw new Error(error?.message);
  }
};
// 获取campaign详情
export const getActiveCampaignDetailApi = async (campaignId: string) => {
  try {
    const response = await axiosInstance.get(
      `/ads/campaign/v3/${campaignId}/updateDraft`
    );
    return response?.data;
  } catch (error: any) {
    throw new Error(error?.message);
  }
};

// 上传黑名单
// 创建 uploadLink
export const createUploadLink = async (fileName: string) => {
  try {
    const response = await axiosInstance.post(
      `/ads/product/uploadLink/public`,
      { key: fileName }
    );
    return response.data;
  } catch (error: any) {
    throw new Error(error?.message);
  }
};

/**
 *
 * @param {any} params 以下是创建流程改版后的新接口
 * @returns
 */

// 创建campaign新接口
export const createCampaignApi = async (params?: any) => {
  try {
    const response = await axiosInstance.post(
      `/ads/campaign/v3/create`,
      params
    );
    return response?.data?.data;
  } catch (error: any) {
    throw new Error(error?.message);
  }
};

// 保存campaign每一步的新接口，统一用一个
export const campaignSaveApi = async (
  campaignId: string,
  params: any,
  currentStep: CreateCampaignStageEnum
) => {
  try {
    const response = await axiosInstance.post(
      `/ads/campaign/v3/${campaignId}/save`,
      { ...params, currentStep }
    );
    return response?.data?.data;
  } catch (error: any) {
    throw new Error(error?.message);
  }
};

// 保存campaign并下一步，统一用一个
export const campaignSaveNextApi = async (
  campaignId: string,
  params: any,
  currentStep: CreateCampaignStageEnum
) => {
  try {
    const response = await axiosInstance.post(
      `/ads/campaign/v3/${campaignId}/next`,
      { ...params, currentStep }
    );
    return response?.data?.data;
  } catch (error: any) {
    throw new Error(error?.message);
  }
};

// 获取businessInfo
export const createBusinessInfoApi = async (campaignId: string) => {
  try {
    const response = await axiosInstance.post(
      `/ads/campaign/v2/${campaignId}/genBusinessInfo`,
      {}
    );
    return response?.data?.data;
  } catch (error: any) {
    throw new Error(error?.message);
  }
};
// 重新生成创意
export const regenerateCreativesApi = async (
  campaignId: string,
  suggestCreatives?: string[]
) => {
  try {
    const response = await axiosInstance.post(
      `/ads/campaign/v2/${campaignId}/genCreative`,
      { suggestCreatives }
    );
    return response?.data?.data;
  } catch (error: any) {
    throw new Error(error?.message);
  }
};

// 重新生成画像
export const regenerateAudienceApi = async (campaignId: string) => {
  try {
    const response = await axiosInstance.post(
      `/ads/campaign/v2/${campaignId}/genAudience`
    );
    return response?.data?.data;
  } catch (error: any) {
    throw new Error(error?.message);
  }
};

// 移除画像
export const removeAudienceApi = async (
  campaignId: string,
  clusterTypeId: string
) => {
  try {
    const response = await axiosInstance.post(
      `/ads/campaign/v2/${campaignId}/personas/${clusterTypeId}/remove`,
      {}
    );
    return response?.data?.data;
  } catch (error: any) {
    throw new Error(error?.message);
  }
};
// 恢复画像
export const recoverAudienceApi = async (
  campaignId: string,
  clusterTypeId: string
) => {
  try {
    const response = await axiosInstance.post(
      `/ads/campaign/v2/${campaignId}/personas/${clusterTypeId}/recover`
    );
    return response?.data?.data;
  } catch (error: any) {
    throw new Error(error?.message);
  }
};
// 移除创意
export const removeCreativesApi = async (
  campaignId: string,
  creativeId: string
) => {
  try {
    const response = await axiosInstance.post(
      `/ads/campaign/v2/${campaignId}/creative/${creativeId}/remove`,
      {}
    );
    return response?.data?.data;
  } catch (error: any) {
    throw new Error(error?.message);
  }
};
// 恢复创意
export const recoverCreativesApi = async (
  campaignId: string,
  creativeId: string
) => {
  try {
    const response = await axiosInstance.post(
      `/ads/campaign/v2/${campaignId}/creative/${creativeId}/recover`
    );
    return response?.data?.data;
  } catch (error: any) {
    throw new Error(error?.message);
  }
};
// 移除创意V2
export const removeCreativesV2Api = async (
  campaignId: string,
  trendId: string
) => {
  try {
    const response = await axiosInstance.post(
      `/ads/campaign/v2/${campaignId}/trend/${trendId}/remove`,
      {}
    );
    return response?.data?.data;
  } catch (error: any) {
    throw new Error(error?.message);
  }
};
// 恢复创意V2
export const recoverCreativesV2Api = async (
  campaignId: string,
  trendId: string
) => {
  try {
    const response = await axiosInstance.post(
      `/ads/campaign/v2/${campaignId}/trend/${trendId}/recover`
    );
    return response?.data?.data;
  } catch (error: any) {
    throw new Error(error?.message);
  }
};
// 创建发布
export const releaseApi = async (campaignId: string) => {
  try {
    const response = await axiosInstance.post(
      `/ads/campaign/v3/${campaignId}/release`
    );
    return response?.data?.data;
  } catch (error: any) {
    throw new Error(error?.message);
  }
};

// 创建流程新的预估接口
// 预估活动效果
export const getEstimateApi = async (campaignId: string, params: any) => {
  try {
    const response = await axiosInstance.post(
      `/ads/campaign/v2/${campaignId}/estimate`,
      params
    );
    return response?.data;
  } catch (error: any) {
    throw new Error(error?.message);
  }
};

// 创建流程新的预估接口-Affiliate marketing模式
// 预估活动效果
export const getAffiliateEstimateApi = async (
  campaignId: string,
  params: any
) => {
  try {
    const response = await axiosInstance.post(
      `/ads/campaign/v2/${campaignId}/estimateAffiliate`,
      params
    );
    return response?.data;
  } catch (error: any) {
    throw new Error(error?.message);
  }
};

// 创建流程新的预估接口-Sales outreach模式
// 预估活动效果
export const getSalesOutreachEstimateApi = async (
  campaignId: string,
  params: any
) => {
  try {
    const response = await axiosInstance.post(
      `/ads/campaign/v2/${campaignId}/estimateSalesOutreach`,
      params
    );
    return response?.data;
  } catch (error: any) {
    throw new Error(error?.message);
  }
};

// 预估活动效果
export const checkLandingUrlApi = async (url: string) => {
  try {
    const response = await axiosInstance.post(`/track/checkSdk`, {
      url,
    });
    return response?.data;
  } catch (error: any) {
    throw new Error(error?.message);
  }
};
// 确认更新活动
export const confirmUpdateApi = async (
  campaignId: string,
  pausePersonaNotMatchOrders?: boolean
) => {
  try {
    const response = await axiosInstance.post(
      `/ads/campaign/v3/${campaignId}/confirmUpdate`,
      {
        pausePersonaNotMatchOrders,
      }
    );
    return response?.data;
  } catch (error: any) {
    throw new Error(error?.message);
  }
};

// 生成创意
export const createTrendApi = async (
  campaignId: string,
  params: { website: string; userIdea?: string }
) => {
  try {
    const response = await axiosInstance.post(
      `/ads/campaign/v2/${campaignId}/genTrend`,
      params
    );
    return response?.data;
  } catch (error: any) {
    throw new Error(error?.message);
  }
};

/**
 * 以下是创建流程中不需要鉴权的接口
 */

// 新建活动-不鉴权
export const createCampaignNoSessionApi = async (tempOrgId: string) => {
  try {
    const response = await axiosInstance.post(
      `/ads/campaign/open/${tempOrgId}/create`,
      {}
    );
    return response?.data?.data;
  } catch (error: any) {
    throw new Error(error?.message);
  }
};

// 生成创意-不鉴权
export const createTrendNoSessionApi = async (
  tempOrgId: string,
  campaignId: string,
  params: { website: string; userIdea?: string }
) => {
  try {
    const response = await axiosInstance.post(
      `/ads/campaign/open/${tempOrgId}/${campaignId}/genTrend`,
      params
    );
    return response?.data;
  } catch (error: any) {
    throw new Error(error?.message);
  }
};

// 获取详情-不鉴权
export const getCampaignDetailNoSessionApi = async (
  tempOrgId: string,
  campaignId: string
) => {
  try {
    const response = await axiosInstance.get(
      `/ads/campaign/open/${tempOrgId}/${campaignId}`
    );
    return response?.data;
  } catch (error: any) {
    throw new Error(error?.message);
  }
};

// 生成businessinfo-不鉴权
export const getBusinessInfoNoSessionApi = async (
  tempOrgId: string,
  campaignId: string
) => {
  try {
    const response = await axiosInstance.post(
      `/ads/campaign/open/${tempOrgId}/${campaignId}/genBusinessInfo`,
      {}
    );
    return response?.data;
  } catch (error: any) {
    throw new Error(error?.message);
  }
};

// 保存或下一步-不鉴权
export const saveCampaignNoSessionApi = async (
  tempOrgId: string,
  campaignId: string,
  params: any
) => {
  try {
    const response = await axiosInstance.post(
      `/ads/campaign/open/${tempOrgId}/${campaignId}/saveOrNext`,
      params
    );
    return response?.data;
  } catch (error: any) {
    throw new Error(error?.message);
  }
};

// 绑定临时组织
export const bindOrgApi = async (tempOrgId: string) => {
  try {
    const response = await axiosInstance.post(
      `/ads/campaign/bind/${tempOrgId}`,
      {}
    );
    return response?.data;
  } catch (error: any) {
    throw new Error(error?.message);
  }
};

// 移除创意V2
export const removeCreativesV2NosessionApi = async (
  campaignId: string,
  tempOrgId: string,
  trendIdOrBatchName: string
) => {
  try {
    const response = await axiosInstance.post(
      `/ads/campaign/open/${tempOrgId}/${campaignId}/trend/${trendIdOrBatchName}/remove`,
      {}
    );
    return response?.data?.data;
  } catch (error: any) {
    throw new Error(error?.message);
  }
};
// 恢复创意V2
export const recoverCreativesNosessionV2Api = async (
  campaignId: string,
  tempOrgId: string,
  trendIdOrBatchName: string
) => {
  try {
    const response = await axiosInstance.post(
      `/ads/campaign/open/${tempOrgId}/${campaignId}/trend/${trendIdOrBatchName}/recover`
    );
    return response?.data?.data;
  } catch (error: any) {
    throw new Error(error?.message);
  }
};

// 修改campaign info信息
export const campaignInfoUpdateApi = async (
  campaignId: string,
  params: any
) => {
  try {
    const response = await axiosInstance.post(
      `/ads/campaign/v3/${campaignId}/update`,
      params
    );
    return response?.data?.data;
  } catch (error: any) {
    throw new Error(error?.message);
  }
};
// 修改campaign other信息
export const campaignOtherUpdateApi = async (
  campaignId: string,
  params: any
) => {
  try {
    const response = await axiosInstance.post(
      `/ads/campaign/v3/${campaignId}/updateOther`,
      params
    );
    return response?.data?.data;
  } catch (error: any) {
    throw new Error(error?.message);
  }
};

// 最新一版的创建流程生成 Product analysis
export const createProductAnalysisApi = async (
  campaignId: string,
  params: { website: string }
) => {
  try {
    const response = await axiosInstance.post(
      `/ads/campaign/v3/${campaignId}/generateGrowthStrategy`,
      params
    );
    return response?.data?.data;
  } catch (error: any) {
    throw new Error(error?.message);
  }
};

// 最新一版的创建流程生成 Product analysis 非鉴权
export const createProductAnalysisOpenApi = async (
  campaignId: string,
  params: { website: string },
  tempOrgId: string
) => {
  try {
    const response = await axiosInstance.post(
      `/ads/campaign/open/${tempOrgId}/${campaignId}/generateGrowthStrategy`,
      params
    );
    return response?.data?.data;
  } catch (error: any) {
    throw new Error(error?.message);
  }
};

// 最新一版的创建流程生成 Product analysis 非鉴权
export const updateCampaignLogoApi = async (
  campaignId: string,
  params: { logo: string }
) => {
  try {
    const response = await axiosInstance.post(
      `/ads/campaign/v3/${campaignId}/updateLogo`,
      params
    );
    return response?.data?.data;
  } catch (error: any) {
    throw new Error(error?.message);
  }
};

// 获取预估出来的头部的达人接口
export const getTopInfluencerApi = async (campaignId: string) => {
  try {
    const response = await axiosInstance.get(
      `/ads/campaign/v3/${campaignId}/topInfluencer`
    );
    return response?.data;
  } catch (error: any) {
    throw new Error(error?.message);
  }
};

// 提交广告主签名
export const submitSignatureApi = async (
  campaignId: string,
  params: { signName: string }
) => {
  try {
    const response = await axiosInstance.post(
      `/ads/campaign/v3/${campaignId}/signature`,
      params
    );
    return response?.data?.data;
  } catch (error: any) {
    throw new Error(error?.message);
  }
};

// 修改影响匹配达人的信息
export const updateMatchInfoApi = async (
  campaignId: string,
  params: {
    intro: string;
    coreFeature: string[];
    coreAudience: {
      audience_name: string;
      audience_description: string;
    };
  }
) => {
  try {
    const response = await axiosInstance.post(
      `/ads/campaign/v3/${campaignId}/updateMatchInfo`,
      params
    );
    return response?.data?.data;
  } catch (error: any) {
    throw new Error(error?.message);
  }
};

// 标记推荐达人
export const markTopInfluencerApi = async (
  campaignId: string,
  params: {
    marketingStrategy: CampaignMarketingStrategy;
    creatorId: string;
    mark: "match" | "notMatch";
  }
) => {
  try {
    const response = await axiosInstance.post(
      `/ads/campaign/v3/${campaignId}/markTopInfluencer`,
      params
    );
    return response?.data?.data;
  } catch (error: any) {
    throw new Error(error?.message);
  }
};
// AI自动优化产品信息
export const optimizeBusinessInfoApi = async (campaignId: string) => {
  try {
    const response = await axiosInstance.post(
      `/ads/campaign/v3/${campaignId}/optimizeBusinessInfo`,
      {}
    );
    return response?.data;
  } catch (error: any) {
    throw new Error(error?.message);
  }
};

// 发布前检查是否需要充值
export const topupCheckApi = async (campaignId: string) => {
  try {
    const response = await axiosInstance.post(
      `/ads/campaign/v3/${campaignId}/topupCheck`,
      {}
    );
    return response?.data?.data;
  } catch (error: any) {
    throw new Error(error?.message);
  }
};

// 获取预览订单
export const previewOrdersApi = async (campaignId: string) => {
  try {
    const response = await axiosInstance.get(
      `/ads/campaign/v3/${campaignId}/previewOrders`
    );
    return response?.data?.data;
  } catch (error: any) {
    throw new Error(error?.message);
  }
};
